var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.03647 0 0 4.04775 0 9.02515C0 10.5796 0.629179 12.189 0.759878 12.5029C0.99696 13.0638 1.44377 13.9081 1.78419 14.4201L7.53799 23.1618C7.88754 23.6952 8.42249 24 9.00304 24C9.58359 24 10.1155 23.6952 10.465 23.1618L16.2188 14.4201C16.5562 13.9081 17.0061 13.0638 17.2432 12.4999C17.3191 12.3139 18 10.6253 18 9.02515C18 4.04775 13.9605 0 9 0ZM9 21.3757L3.6231 13.204C3.3617 12.8047 2.97264 12.0762 2.79331 11.6434C2.78723 11.6281 2.20669 10.2169 2.20669 9.02515C2.20669 5.26695 5.25532 2.2098 9.00304 2.2098C12.7508 2.2098 15.7994 5.26695 15.7994 9.02515C15.7994 10.0157 15.3799 11.2441 15.2158 11.6403V11.6464C15.0334 12.0762 14.6444 12.8047 14.383 13.204L9.00304 21.3757H9Z",
    fill: "#003DA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 3.95935C6.21578 3.95935 3.9483 6.23012 3.9483 9.02514C3.9483 11.8202 6.21274 14.0909 8.99998 14.0909C11.7872 14.0909 14.0516 11.8202 14.0516 9.02514C14.0516 6.23012 11.7872 3.95935 8.99998 3.95935ZM8.99998 6.16915C10.5714 6.16915 11.848 7.44932 11.848 9.02514C11.848 10.601 10.5714 11.8811 8.99998 11.8811C7.42855 11.8811 6.15195 10.601 6.15195 9.02514C6.15195 7.44932 7.42855 6.16915 8.99998 6.16915Z",
    fill: "#3366CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.06caf047ebcdfe68e24c323525eb981b.svg";
export { ForwardRef as ReactComponent };